import { render, staticRenderFns } from "./TranslateReport.vue?vue&type=template&id=3191b1de&"
import script from "./TranslateReport.vue?vue&type=script&lang=js&"
export * from "./TranslateReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports